export default "__VITE_PUBLIC_ASSET__dbf9355a__"